<template>
  <BaseLayoutGrid
    class="jps-curation-view-tile"
    :class="{
      'page-hina': isHina,
      'page-jps': isJps,
    }"
  >
    <div
      v-for="item in items"
      class="grid-item jps-card-flexible"
      :key="item.key"
    >
      <UiButtonIcon
        tag="button"
        v-if="editable"
        class="jps-icon-button list-delete"
        @click.stop="emits('delete-item', item)"
        icon="mdi/close-circle"
      />
      <div class="grid-card-content" v-if="!item.readNext">
        <BaseLink
          :show-icon="false"
          class="card-image jps-relative"
          aria-hidden="true"
          v-bind="baseLinkProps(item)"
          @click="emits('show-modal', item)"
        >
          <UiImageSelection
            :type="item.type"
            :image="item.image"
            :appearance="{
              borderRadius: 'medium',
              hoverScale: true,
            }"
            image-usage="thumbnail"
          />
          <ListEditIcon :item="item" field="image" :editstate="editstate" />
        </BaseLink>
        <BaseLink
          class="jps-card-flexible-meta"
          v-bind="baseLinkProps(item)"
          @click="emits('show-modal', item)"
        >
          <span class="is-size-6 has-text-weight-bold">
            {{ ls(item.title) }}
            <ListEditIcon :item="item" field="title" :editstate="editstate" />
            <ListEditIcon :item="item" field="url" :editstate="editstate" />
            <ListEditIcon
              :item="item"
              field="linkUrl"
              :editstate="editstate"
            />
          </span>
        </BaseLink>
        <div class="grid-content-scroll">
          <p
            class="jps-card-small-meta is-size-7"
            v-if="isJps && item.type === 'item' && item.data"
          >
            <UiOrgProviderSpan :id="item.data.common.provider" />
          </p>
          <p class="jps-grid-description">
            <ListEditIcon
              :item="item"
              field="description"
              :editstate="editstate"
            />
            {{ ls(item.description) }}
          </p>
        </div>
        <div class="jps-grid-bottom">
          <UiInteractPanel
            v-if="!editable && item.data"
            class="jps-card-icon"
            :type="item.type"
            :data="item.data"
            :image="item.image"
          />
        </div>
      </div>
      <SearchResultDiv
        v-else
        :item="item"
        :editstate="editstate"
        :key="item.key"
      />
    </div>
    <div class="list-add-div" v-if="editable && !isNote">
      <button
        class="jps-icon-button list-add-button jps-sub-orange"
        @click="emits('add')"
      >
        <BaseIcon name="mdi/plus-circle" :alt="ls(addPartMsg)" size="size-4" />
      </button>
    </div>
  </BaseLayoutGrid>
</template>

<script lang="ts" setup>
const { ls } = useI18n()

interface Props {
  editstate?: CurationEditState
  def : PartList
  items: ListElement[]
}
const props = withDefaults(defineProps<Props>(), {})

const emits = defineEmits(['delete-item', 'show-modal', 'add'])

const {
  isNote,
  baseLinkProps,
  editable,
  addPartMsg,
} = useCurationListView(props.editstate, props.def)

const { isJps, isHina } = useServiceType()
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-grid-description {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 0.5rem;
}

.jps-curation-view-tile {
  padding: 0;
  .grid-item {
    // background: $white;
    // border-radius: $global-radius;
    .list-delete {
      position: absolute;
      top: 2px;
      right: 2px;
      z-index: 1000;
      margin-right: 6px;
      background: $jps-gray-50;
    }

    /* overflow: hidden; */
    max-width: none;
    /* margin-bottom: 3rem; */

    .grid-card-content {
      display: grid;
      grid-template-rows: 180px auto auto 1fr;
      height: 360px;

      .card-image {
        // border-radius: $global-radius;
        display: block;
        // overflow: hidden;
        width: 100%;
        :deep(.ui-button-icon) {
          margin-right: 6px;
        }
      }
      .jps-card-flexible-meta {
        display: block;
        padding: 0.75rem 0.5rem 0.25rem 0.5rem;
      }
      .jps-card-small-meta {
        padding-left: 0.5rem;
        padding-bottom: 0.25rem;
      }
      .grid-content-scroll {
        overflow-y: scroll;
        @include no-scrollbar();
        .jps-grid-description {
          font-size: 0.875rem;
          padding-bottom: 0;
        }
      }
      .jps-grid-bottom {
        /* position: absolute; */
        border-radius: $global-radius-small;
        /* bottom: 0; */
        width: 100%;
        // background: $white;
        .jps-interact-panel {
          width: 100%;
        }
      }
    }

    .jps-show-more {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    // 画像編集アイコンの位置調整
    :deep(.edit-image-static) {
      position: absolute;
      right: 4px;
      bottom: 0px;
    }

  }
}
.jps-curation-view-tile {
  .list-add-div {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
  }
}

.page-hina {
  .grid-item {
    .grid-card-content {
      .grid-content-scroll {
        > * {
          color: $hina-text-sub;
        }
      }
    }
  }
}
</style>
